import Dashboard from './views/Dashboard'
import TemplateManager from './views/TemplateManager'
import TemplateBuilder from './views/TemplateBuilder'
import ContentPages from './views/ContentPages.vue'
import ContentPagesList from './views/ContentPagesList.vue'
import Menus from './views/WebsiteMenus.vue'
import CheckoutSettings from './views/CheckoutSettings.vue'
import Marquees from './views/Marquees.vue'
import FeaturedProducts from './views/FeaturedProducts.vue'
import NewsAlerts from './views/NewsAlerts.vue'
import SocialMedia from './views/SocialMedia.vue'
import DepartmentLinks from './views/DepartmentLinks.vue'
import SuggestedItemDepartments from './views/SuggestedItemDepartments.vue'
import FeaturedCollections from './views/FeaturedCollections.vue'
import Settings from './views/Settings.vue'
import AutoPilot from './views/AutoPilot.vue'

const WebsiteRoutes = [
    {
        path: '/website',
        component: () => import(/* webpackChunkName: "website-module" */ './WebsiteModule.vue'),
        children: [
            { path: '', name: 'Website Dashboard', component: Dashboard },
            { path: 'template-manager', name: 'Template Manager', component: TemplateManager },
            { path: 'template-manager/:template_id', name: 'Template Builder', component: TemplateBuilder, props: true },
            { path: 'marquees', component: Marquees, name: 'Marquee Banners' },
            { path: 'marquees/:marquee_id', component: Marquees, name: 'Marquee Banner Detail', props: true },
            { path: 'featured-products', name: 'Featured Products', component: FeaturedProducts },
            { path: 'featured-products/:feature_product_id', name: 'Featured Product Detail', component: FeaturedProducts, props: true },
            { path: 'content-pages', component: ContentPages, children: [
    				{ path: '', name: 'Content Pages', component: ContentPagesList, props: true },
    				{ path: ':id', name: 'Content Page', component: () => import(/* webpackChunkName: "content-pages-detail" */ './views/ContentPagesDetail.vue'), props: true }
			    ]
		    },
            { path: 'menus', name: 'Site Menus', component: Menus },
            { path: 'checkout', name: 'Checkout Settings', component: CheckoutSettings, props: true },
    		{ path: 'checkout/:setting', name: 'Checkout Settings Detail', component: CheckoutSettings, props: true },
            { path: 'news-alerts', name: 'News Alerts', component: NewsAlerts },
            { path: 'social-media', name: 'Social Media', component: SocialMedia },
            { path: 'department-links', name: 'Department Links', component: DepartmentLinks },
            { path: 'best-sellers', name: 'Best Sellers', component: SuggestedItemDepartments },
            { path: 'featured-collections', name: 'Featured Collections', component: FeaturedCollections },
            { path: 'settings/:setting', name: 'Settings', component: Settings, props: true },
            { path: 'auto-pilot', name: 'Auto Pilot', component: AutoPilot }
        ]
    }
]

export default WebsiteRoutes
